import d2admin from '@/d2admin'
import system from '@/pages/stores'
// import esource from '@esource/stores'
// import elink from '@elink/stores'
// import research from '@research/stores'

export default {
  d2admin: d2admin,
  system: system
  // elink,
  // research,
  // esource
  // main: main,
  // work: work,
  // edc: edc
}
